import { Grid } from 'antd';

/**
 * 是否為手機寬度（< 768px，AntD `md`）。
 * 用 `=== false` 而非 `!md`：首次 render 時 breakpoint 還是 `{}`，否則桌機會先閃一下手機版。
 */
export function useIsMobile(): boolean {
  return Grid.useBreakpoint().md === false;
}

/** Drawer 寬度：手機滿版，桌機用指定寬度。 */
export function useDrawerWidth(desktop: number | string): number | string {
  return useIsMobile() ? '100%' : desktop;
}
